import React, { ReactNode } from "react";
import Card from "components/ui/Card/Card";
import Spinner from "components/ui/Spinner/Spinner";
import styles from "./ChartCard.module.scss";
import { useI18n } from "context/I18nContext";

type Props = {
  title: string;
  subtitle?: string;
  children: ReactNode;
  loading?: boolean;
  emptyMessage?: string;
  isEmpty?: boolean;
};

function ChartCard({
  title,
  subtitle,
  children,
  loading = false,
  emptyMessage,
  isEmpty = false,
}: Props) {
  const { t } = useI18n();
  const resolvedEmptyMessage = emptyMessage ?? t("dashboardPage.charts.empty");
  const loadingLabel = t("dashboardPage.charts.loading");

  let body = children;

  if (loading) {
    body = (
      <div className={styles.loader}>
        <Spinner size="sm" label={loadingLabel} />
      </div>
    );
  } else if (isEmpty) {
    body = <p className={styles.empty}>{resolvedEmptyMessage}</p>;
  }

  return (
    <Card className={styles.card}>
      <header className={styles.header}>
        {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
        <h3 className={styles.title}>{title}</h3>
      </header>
      <div className={styles.content}>{body}</div>
    </Card>
  );
}

export default ChartCard;
